import PageWrapper from "../../shared/wizard/PageWrapper";
import Styles from "../AnonForms.module.css";
import { states } from "../../../constants/data";
import { vehicleMakes, yesNo } from "../../../constants/options";

function OtherVehicle({
  fields,
  utilities,
}) {

  const {
    createToggleInput,
    createNoLabelInput,
    createNoLabelSelect,
    createTextArea
  } = utilities;

  return (
    <PageWrapper legendInfo="Other Vehicle:">
      {createToggleInput(fields.otherVehicleInvolved, "100%", yesNo, true)}
      {
      fields.otherVehicleInvolved.value && (
        <div className={`${Styles.fadeIn} ${Styles.labelInputContainer}`}>
          <p className={Styles.sectionLabel}>Other Vehicle Information</p>
          <div className={` ${Styles.formRow}`}>
            {createNoLabelInput(fields.otherVehicleYear, "100%", Styles.anonInput)}
            {createNoLabelSelect(
              fields.otherVehicleMake,
              "100%",
              vehicleMakes.map(make => make.name),
              Styles.anonSelect,
              "Select a make"
              )}
            {createNoLabelInput(fields.otherVehicleModel, "100%", Styles.anonInput)}
          </div>

          <div className={Styles.formRow}>
            {createNoLabelInput(fields.otherVehiclePlateNumber, "29%", Styles.anonInput)}
            {createNoLabelSelect(
              fields.otherVehicleState,
              "10rem",
              states,
              Styles.anonSelect,
              "Select a State"
            )}
          </div>
          <div className={Styles.formColumn}>
            {createTextArea(
              fields.otherVehicleDescribe,
              "100%",
              true,
              Styles.anonTextarea
            )}
          </div>
          <div className={`${Styles.formRow}`}>
          <div className={Styles.groupedInputs}>
            <div className={Styles.labelContainer}>
              <p className={Styles.label}>Who was driving the vehicle?</p>
            </div>
            {createNoLabelInput(fields.otherVehicleDriverFirstName, "100%", Styles.anonInput)}
            {createNoLabelInput(fields.otherVehicleDriverLastName, "100%", Styles.anonInput)}
          </div>
          </div>
             <div className={`${Styles.formRow}`}>
            <div className={Styles.groupedInputs}>
              {createToggleInput(fields.otherVehicleDriverInjured, "100%", yesNo, true)}
            </div>
          </div>

          <p className={Styles.sectionLabel}>Other Driver Information</p>
          <div className={`${Styles.formRowExtended} ${Styles.formRow}`}>
            {createNoLabelInput(fields.otherVehicleDriverAddress, "100%", Styles.anonInput)}
            {createNoLabelInput(fields.otherVehicleDriverCity, "100%", Styles.anonInput)}
          </div>
          <div className={Styles.formRow}>
            {createNoLabelSelect(fields.otherVehicleDriverState, "100%", states, Styles.anonSelect, "Select a State")}
            {createNoLabelInput(fields.otherVehicleDriverZipcode, "100%", Styles.anonInput)}
            {createNoLabelInput(fields.otherVehicleDriverPhone, "100%", Styles.anonInput, "tel")}
          </div>
          <div className={`${Styles.formRowExtended} ${Styles.formRow}`}>
            {createToggleInput(fields.otherDriverIsOwner, "50%", yesNo, true)}
          </div>
          {!fields.otherDriverIsOwner.value && (
            <>
              <p className={Styles.sectionLabel}>Other Owner's Information</p>
              <div className={`${Styles.formRowExtended} ${Styles.formRow}`}>
                {createNoLabelInput(fields.otherVehicleOwnerFirstName, "100%", Styles.anonInput)}
                {createNoLabelInput(fields.otherVehicleOwnerLastName, "100%", Styles.anonInput)}
              </div>
              <div className={`${Styles.formRowExtended} ${Styles.formRow}`}>
                {createNoLabelInput(fields.otherVehicleOwnerAddress, "100%", Styles.anonInput)}
                {createNoLabelInput(fields.otherVehicleOwnerCity, "100%", Styles.anonInput)}
              </div>
              <div className={`${Styles.formRowExtended} ${Styles.formRow}`}>
                {createNoLabelSelect(
                  fields.otherVehicleOwnerState,
                  "14rem",
                  states,
                  Styles.anonSelect,
                  "Select a State"
                )}
                {createNoLabelInput(fields.otherVehicleOwnerZipcode, "6rem", Styles.anonInput)}
                {createNoLabelInput(fields.otherVehicleOwnerPhone, "29%", Styles.anonInput, "tel")}
              </div>
            </>
          )}
        </div>
      )}
    </PageWrapper>
  );
}

export default OtherVehicle;
